module.exports = __webpack_public_path__ + "f510bc562448f62d79431bdc9d2e832e.svg";